import Vue from "vue";
import Vuex from "vuex";
import axios from 'axios';
import Cookies from 'js-cookie'
import i18n from './i18n';
import router from './router';
import { DateTime } from 'luxon';

import {getAccountUsingGET} from '@/api';

Vue.use(Vuex);

const token = Cookies.get('token')
if(token) {
    axios.defaults.headers.common['Authorization'] = "Bearer " + token;
}

export default new Vuex.Store({
  state: {
      isAuthenticated: token !== undefined,
      token: token? token : null
  },
  mutations: {
    loggedIn(state, newToken) {
        state.isAuthenticated = true;
        state.token = newToken;
        axios.defaults.headers.common['Authorization'] = "Bearer " + newToken;
        Cookies.set('token', newToken, { expires: 7 });
		
		getAccountUsingGET().then(response => {
            i18n.locale = response.data.langKey;
            Cookies.set('langKey',response.data.langKey, { expires: 365 });

            let passwordChangedOn = DateTime.fromISO(response.data.passwordChangedOn),
                now = DateTime.local();

            /*
            if(passwordChangedOn.plus({ days: 90 }) < now) {
                Vue.swal({
                    title: i18n.$t("Jelszó"),
                    text: i18n.$t("A jelenlegi jelszava lejárt. Az e-mail címére elküldtük a jelszó cseréhez szükséges hivatkozást."),
                    imageUrl: window.swalError,
                });
                this.commit('logout');
                router.push({name: 'login'});
            }
            */
        });
    },
    logout(state) {
        state.isAuthenticated = false;
        state.token = null;
        delete axios.defaults.headers.common['Authorization'];
        Cookies.remove('token');
    }
  },
  actions: {}
});
